import { restApi } from '../../../services/Api'

const resumoRepository = {}

resumoRepository.getResumo = id => {
  return restApi.get(`solicitacoes/${id}/resumo`)
}

export default resumoRepository
